import { Field, FieldArray, Form, Formik } from 'formik';
import { useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import validAllowedCharacters from '../../../constants/valid-character-password';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import LoaderButton from '../../../shared-components/button/loader-button';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormTextArea from '../../../shared-components/FormikFormHandlers/FormikFormTextArea';
import { UpdateTeplarValidateSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import { CloseModalIcon } from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';

const UpdateTeplarPrintForm = (props: IAddEditFormProps<any>) => {
  const inputRefs = useRef([]);
  return (
    <>
      <Modal
        className="correction-modal1 fancy-modal"
        show={true}
        size="xl"
        centered
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id="update_teplar" />
            <button
              onClick={props.onModalClosed}
              disabled={props.isLoading}
              className="Crossicons"
            >
              <CloseModalIcon />
            </button>
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={{
            ProductId: props.initialValues?.ProductId || '',
            Katashiki: props.initialValues?.Katashiki || '',
            Format: props.initialValues?.Format || '',
            Layout: props.initialValues?.Layout || 0,
            Width: props.initialValues?.Width || 0,
            Items: props.initialValues?.Items || [''],
            Remarks: props.initialValues?.Remarks || '',
          }}
          enableReinitialize
          validationSchema={UpdateTeplarValidateSchema}
          validateOnBlur={false}
          onSubmit={async (values) => {
            props.submitHandler(values);
          }}
        >
          {({ values, dirty, setFieldValue, handleChange }) => {
            useEffect(() => {
              const lastIndex = values.Items.length - 1;
              if (inputRefs.current[lastIndex]) {
                inputRefs.current[lastIndex].focus();
              }
            }, [values.Items.length]);
            return (
              <Form
                className="user-form"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
              >
                {props.isLoading && (
                  <FormLoader loading={props.isLoading} contained />
                )}
                <Modal.Body>
                  <div className="row">
                    <div className="col">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="product_id"
                        />
                        <Field
                          data-testid="testProductId"
                          className="form-control"
                          name="ProductId"
                          type="text"
                          placeholder=""
                          as={FormikFormInput}
                          disabled={props.id > 0}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          label="katashiki"
                        />
                        <Field
                          data-testid="testkatashiki"
                          className="form-control"
                          name="Katashiki"
                          type="text"
                          validcharacter={validAllowedCharacters}
                          defaultValue={undefined}
                          placeholder=""
                          as={FormikFormInput}
                        />
                      </div>
                    </div>

                    <div className="col">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          label="format"
                        />
                        <Field
                          name="Format"
                          data-testid="testformat"
                          className="form-control"
                          defaultValue={undefined}
                          placeholder=""
                          as={FormikFormInput}
                          validcharacter={validAllowedCharacters}
                        />
                      </div>
                    </div>

                    <div className="col-lg-1 col-md-2 col-6">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          label="layout"
                        />
                        <Field
                          name="Layout"
                          data-testid="testlayout"
                          className="form-control"
                          placeholder=""
                          type="text"
                          as={FormikFormInput}
                        />
                      </div>
                    </div>

                    <div className="col-lg-1 col-md-1 col-6">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          label="width"
                        />
                        <Field
                          name="Width"
                          data-testid="testwidth"
                          className="form-control"
                          placeholder=""
                          as={FormikFormInput}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="bg-light rounded p-3 my-2">
                    <div className="row items-block">
                      <FieldArray name="Items">
                        {({ remove, push }) => (
                          <>
                            {values.Items.map((_: string, index: number) => {
                              return (
                                <div
                                  className="col-lg-2 col-md-2 col-6"
                                  key={index}
                                  style={{ position: 'relative' }}
                                >
                                  <label>{`${formatMessage('items')} ${index + 1}`}</label>
                                  <div key={index}>
                                    <div className="form-group formSet">
                                      <Field
                                        className="form-control"
                                        name={`Items.${index}`}
                                        type="text"
                                        onChange={handleChange}
                                        innerRef={(el) =>
                                          (inputRefs.current[index] = el)
                                        }
                                      />
                                    </div>
                                  </div>
                                  {/* <button
                                    type="button"
                                    className="btn btn-danger btn-sm mt-1"
                                    onClick={() => remove(index)}
                                  >
                                    {formatMessage('remove')}
                                  </button> */}
                                  <button
                                    type="button"
                                    onClick={() => remove(index)}
                                    className="btn btn-danger btn-sm mt-1 remove-btn"
                                  >
                                    &times;
                                  </button>
                                </div>
                              );
                            })}
                            <div className="col-3 addItemTepler">
                              <button
                                type="button"
                                onClick={() => push('')}
                                className="btn btn-primary"
                              >
                                + {formatMessage('add_item')}
                              </button>
                            </div>
                          </>
                        )}
                      </FieldArray>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          label="remarks"
                        />
                        <Field
                          name="Remarks"
                          data-testid="testwidth"
                          className="form-control"
                          defaultValue={undefined}
                          placeholder=""
                          as={FormikFormTextArea}
                        />
                      </div>
                    </div>
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  <div className="d-flex justify-content-center ">
                    <div className="row tab-action g-0">
                      <div className="col-12">
                        <Button
                          variant="light-danger"
                          type="button"
                          onClick={props.onModalClosed}
                          disabled={props.isLoading}
                        >
                          <FormattedMessage id="cancel" />
                        </Button>
                        <LoaderButton
                          type="submit"
                          isLoading={props.isLoading}
                          text="update"
                        />
                      </div>
                    </div>
                  </div>
                </Modal.Footer>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};

export default UpdateTeplarPrintForm;
